// src/utils/cookieConsent.js
const COOKIE_NAME = 'cookie_consent';
const EXPIRE_DAYS = 180;

function setCookie(name, value, days) {
	const date = new Date();
	date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function getCookie(name) {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	return match ? match[2] : null;
}

export function hasConsent() {
	return getCookie(COOKIE_NAME) === 'true';
}

export function giveConsent() {
	setCookie(COOKIE_NAME, 'true', EXPIRE_DAYS);
}
